<template>
  <div :class="`component__carousel--${props.iteration}`">
    <div class="mw--1000 carousel__wrapper">
      <div :class="carouselIteration">
        <div
          class="carousel__product"
          v-for="(item, key) in carousel[props.iteration]"
          :key="item"
        >
          <div>
            <img class="carousel__img--product opacity--0" :src="item.img" />
          </div>
          <div class="product-title pt--30">Smirnoff</div>
          <div class="carousel__h1 px--20" v-html="item.title"></div>
          <div class="grad-border">
            <button
              :class="item.classes"
              class="carousel__button mp--m"
              v-html="item.buttontext"
              :data-id="key"
              :data-asset-id="item.dataAssetId"
              :data-product-sku="item.dataProductSku"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cs-modal">
    <div class="cs-modal__bg">
      <div class="cs-modal__padding">
        <div class="cs-modal__row cs-modal__row--1">
          <div class="cs-modal__close"><img src="arrow-back.svg" /></div>
          <div class="cs-modal__col--6-6">
            <div class="cs-modal__copy">
              <div class="cs-modal__copy-title"></div>
              <div class="cs-modal__copy-ingredients"></div>
              <div class="cs-modal__copy-method"></div>
              <div class="cs-modal__cta">
                <div class="cs-modal__grad-border cswidget">
                  <button
                    class="cs-modal__hidden cs-modal__button cs-modal__button--1 mp--m cswidget"
                    data-asset-id="4160"
                    data-product-sku="768936, 700781, 771546, 772387, 724823, 765548, 768849, 767146, 767147"
                  >
                    BUY NOW</button
                  ><button
                    class="cs-modal__hidden cs-modal__button cs-modal__button--2 mp--m cswidget"
                    data-asset-id="4160"
                    data-product-sku="771546, 768936, 700781, 772387, 724823, 765548, 768849, 767146, 767147"
                  >
                    BUY NOW</button
                  ><button
                    class="cs-modal__hidden cs-modal__button cs-modal__button--3 mp--m cswidget"
                    data-asset-id="4160"
                    data-product-sku="772387, 700781, 768936, 771546, 724823, 765548, 768849, 767146, 767147"
                  >
                    BUY NOW</button
                  ><button
                    class="cs-modal__hidden cs-modal__button cs-modal__button--4 mp--m cswidget"
                    data-asset-id="4160"
                    data-product-sku="771546, 768936, 700781, 772387, 724823, 765548, 768849, 767146, 767147"
                  >
                    BUY NOW</button
                  ><button
                    class="cs-modal__hidden cs-modal__button cs-modal__button--5 mp--m cswidget"
                    data-asset-id="4160"
                    data-product-sku="700781, 768936, 771546, 772387, 724823, 765548, 768849, 767146, 767147"
                  >
                    BUY NOW
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="cs-modal__col--6-6">
            <div class="cs-modal__serve">
              <img class="cs-modal__img--serve" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import dataModel from "../js/model.js";
import gsap from "gsap";
const props = defineProps({
  iteration: {
    type: String,
    default: "1",
  },
  brandExperience: {
    type: String,
    default: "1",
  },
});
var carouselIteration = "carousel--" + props.iteration;
var carousel = {
  1: {
    1: {
      title: "Raspberry Crush & Lemonade​ Spritz",
      img: "products/raspberry-crush.png",
      buttontext: "get recipe",
      url: "",
      classes: "carousel__button--recipes",
      modalTitle: "Smirnoff Raspberry Crush & Lemonade​ Spritz",
      modalIngredients:
        "<div>50ML SMIRNOFF RASPBERRY CRUSH</div><div>​75ML LEMONADE</div><div>​50ML PROSECCO​</div><div>ICE CUBES</div><div>​GARNISH: 2-3 RASPBERRIES</div>",
      modalMethod:
        "FILL GLASS WITH ICE. ADD SMIRNOFF RASPBERRY CRUSH THEN ADD PROSECCO. ADD THE LEMONADE AND GARNISH WITH RASPBERRIES THEN SERVE. ",
      dataProductSku:
        "768936, 700781, 771546, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    2: {
      title: "Mango & Passionfruit Lemonade Spritz",
      img: "products/mango-spritz.png",
      buttontext: "get recipe",
      url: "",
      classes: "carousel__button--recipes",
      modalTitle: "Smirnoff Mango & Passionfruit Lemonade Spritz",
      modalIngredients:
        "<div>50ml Smirnoff Mango & Passionfruit Twist</div><div>75ml Lemonade</div><div>50ml Prosecco</div><div>Ice Cubes</div><div>Garnish: Lime</div>",
      modalMethod:
        "Fill Glass with ice. Add Smirnoff Mango & Passionfruit Twist then add Prosecco. Add the Lemonade and garnish with Lime then serve.",
      dataProductSku:
        "771546, 768936, 700781, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    3: {
      title: "Berry Burst Lemonade Spritz",
      img: "products/berry-spritz.png",
      buttontext: "get recipe",
      url: "",
      classes: "carousel__button--recipes",
      modalTitle: "Smirnoff Berry Burst Lemonade Spritz",
      modalIngredients:
        "<div>50ml Smirnoff Berry Burst</div><div>75ml Lemonade</div><div>50ml Prosecco</div><div>Cubed ice</div>",
      modalMethod:
        "FILL GLASS WITH ICE. ADD SMIRNOFF BERRY BURST THEN ADD PROSECCO. ADD THE LEMONADE AND GARNISH WITH BLUEBERRIES/BLACKBERRIES THEN SERVE.",
      dataProductSku:
        "772387, 700781, 768936, 771546, 724823, 765548, 768849, 767146, 767147",
    },
    4: {
      title: "Smirnoff Mango & Passionfruit Martini Cocktail",
      img: "products/passionfruit-martini.png",
      buttontext: "get recipe",
      url: "",
      classes: "carousel__button--recipes",
      modalTitle: "Smirnoff Mango & Passionfruit Martini Cocktail",
      modalIngredients:
        "<div>50ml Smirnoff Mango & Passionfruit Twist</div><div>75ml Pineapple Juice</div><div>50ml Cranberry Juice</div><div>Ice Cubes</div><div>Garnish: 1/2 a fresh Passionfruit</div>",
      modalMethod:
        "Add all liquid ingredients to a cocktail shaker. Fill shaker with ice and shake for 15 seconds. Fine strain into chilled martini glass and garnish with Passionfruit and serve.",
      dataProductSku:
        "771546, 768936, 700781, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    5: {
      title: "Lemonade Spritz",
      img: "products/lemonade-spritz.png",
      buttontext: "get recipe",
      url: "",
      classes: "carousel__button--recipes",
      modalTitle: "Smirnoff Lemonade Spritz",
      modalIngredients:
        "<div>50ml SMIRNOFF No. 21 RED</div><div>150ml LEMONADE</div><div>ICE CUBES</div><div>GARNISH: 2-3 RASPBERRIES + WEDGE OF LIME</div>",
      modalMethod:
        "Fill a glass with ice. Add Smirnoff and fill up with lemonade, garnish with raspberries and a wedge of lime then&nbsp;serve.",
      dataProductSku:
        "700781, 768936, 771546, 772387, 724823, 765548, 768849, 767146, 767147",
    },
  },
  2: {
    1: {
      title:
        "Raspberry Crush Vodka<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70cl, 37.5% ABV</span>",
      img: "products/raspberry-vodka.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "768936, 700781, 771546, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    2: {
      title:
        "No.21 Red Label Vodka<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70cl, 37.5% ABV</span>",
      img: "products/no21-vodka.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "700781, 768936, 771546, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    3: {
      title:
        "Mango & Passionfruit Twist Vodka<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70cl, 37.5% ABV</span>",
      img: "products/mango-vodka.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "771546, 768936, 700781, 772387, 724823, 765548, 768849, 767146, 767147",
    },
    4: {
      title:
        "Berry Burst Vodka<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70cl, 37.5% ABV</span>",
      img: "products/berry-vodka.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "772387, 771546, 768936, 700781, 724823, 765548, 768849, 767146, 767147",
    },
    5: {
      title:
        "Smirnoff Ice<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70cl, 4% ABV</span>",
      img: "products/ice.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "724823, 765548, 768849, 767146, 767147, 772387, 771546, 768936, 700781",
    },
    6: {
      title:
        "Smirnoff Ice Tropical<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70CL, 4% ABV</span>",
      img: "products/ice-tropical.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "765548, 724823, 768849, 767146, 767147, 772387, 771546, 768936, 700781",
    },
    7: {
      title:
        "Smirnoff Ice Raspberry<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">70CL, 4% ABV</span>",
      img: "products/ice-raspberry.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "768849, 765548, 724823, 767146, 767147, 772387, 771546, 768936, 700781",
    },
    8: {
      title:
        "Orange & Grapefruit Seltzer<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">4x250ml can, 4.7% ABV</span>",
      img: "products/seltzer-orange.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "767146, 767147, 768849, 765548, 724823, 772387, 771546, 768936, 700781",
    },
    9: {
      title:
        "Raspberry & Rhubarb Seltzer<br><span style=\"font-family: 'Mark Pro'; font-size: 15px;font-weight: bold;text-transform: uppercase;\">4x250ml can, 4.7% ABV</span>",
      img: "products/seltzer-raspberry.png",
      buttontext: "buy now",
      url: "",
      classes: "cswidget",
      dataAssetId: "4160",
      dataProductSku:
        "767147, 767146, 768849, 765548, 724823, 772387, 771546, 768936, 700781",
    },
  },
};
$(document).ready(function () {
  $(document).on("click", ".carousel__button--recipes", function () {
    var dId = $(this).attr("data-id");

    //show the modal
    $(".cs-modal").css({
      display: "flex",
    });

    $(`.cs-modal__button--${dId}`).removeClass("cs-modal__hidden");

    $(".cs-modal__img--serve").attr("src", carousel[1][dId].img);
    $(".cs-modal__copy-title").html(carousel[1][dId].modalTitle);
    $(".cs-modal__copy-ingredients").html(carousel[1][dId].modalIngredients);
    $(".cs-modal__copy-method").html(carousel[1][dId].modalMethod);
  });
  $(document).on("click", ".cs-modal__close", function () {
    gsap.to(".cs-modal__bg", {
      opacity: 0,
      duration: 0.25,
      onComplete: () => {
        gsap.set(".cs-modal__bg", {
          opacity: 1,
          delay: 0.5,
        });
      },
    });
    gsap.to(".cs-modal", {
      opacity: 0,
      delay: 0.25,
      duration: 0.5,
      onComplete: () => {
        gsap.set(".cs-modal", {
          opacity: 1,
          display: "none",
        });
        $(".cs-modal__button").addClass("cs-modal__hidden");
      },
    });
  });
});
$(document).ready(function () {
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .prepend(
      `<img class="carousel__previous--${props.iteration}" src="left-arrow.svg" width="20" style="position: absolute;top: calc(50% - 80px);z-index: 1150;left: 20px">`
    );
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .append(
      `<img class="carousel__next--${props.iteration}" src="right-arrow.svg" width="20" style="position: absolute;top: calc(50% - 80px);z-index: 1150;right: 20px;">`
    );

  $("." + carouselIteration).slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    initialSlide: 0,
    slidesToScroll: 1,
    prevArrow: $(".carousel__previous--" + props.iteration),
    nextArrow: $(".carousel__next--" + props.iteration),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //initiate 1st tab on load
  var reOrderingElems = function () {
    if (props.brandExperience == 1) {
      window.innerWidth < 600
        ? $(".carousel--1").slick("slickGoTo", 0)
        : $(".carousel--1").slick("slickGoTo", 4);
      window.innerWidth < 600
        ? $(".carousel--2").slick("slickGoTo", 0)
        : $(".carousel--2").slick("slickGoTo", 0);
    } else if (props.brandExperience == 2) {
      window.innerWidth < 600
        ? $(".carousel--1").slick("slickGoTo", 1)
        : $(".carousel--1").slick("slickGoTo", 5);
      window.innerWidth < 600
        ? $(".carousel--2").slick("slickGoTo", 2)
        : $(".carousel--2").slick("slickGoTo", 1);
    } else if (props.brandExperience == 3) {
      window.innerWidth < 600
        ? $(".carousel--1").slick("slickGoTo", 2)
        : $(".carousel--1").slick("slickGoTo", 6);
      window.innerWidth < 600
        ? $(".carousel--2").slick("slickGoTo", 3)
        : $(".carousel--2").slick("slickGoTo", 1);
    } else {
      window.innerWidth < 600
        ? $(".carousel--1").slick("slickGoTo", 4)
        : $(".carousel--1").slick("slickGoTo", 4);
      window.innerWidth < 600
        ? $(".carousel--2").slick("slickGoTo", 1)
        : $(".carousel--2").slick("slickGoTo", 0);
    }
  };
  reOrderingElems();

  $(".api__navbar-option").on("click", function () {
    var dId = $(this).attr("data-id");

    switch (dataModel[1].ui.retailers[dId].bgColor) {
      case "#bc0e2d":
        break;
    }
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.cs-modal__cta {
  margin-top: 20px;
}
.cs-modal__hidden {
  display: none;
}
.cs-modal__button {
  background: linear-gradient(
    to right,
    rgb(172, 118, 38),
    rgb(211, 168, 90),
    rgb(172, 118, 38)
  );
  color: #ffffff;
  padding: 10px 25px 10px 25px;
  font-size: 18px;
  width: 100%;
  &:hover {
    background: transparent;
    color: rgb(172, 118, 38);
    cursor: pointer;
  }
}
.cs-modal__grad-border {
  width: 171px;
  margin: 0 auto;
  padding: 3px;
  border-width: 2px;
  border-style: solid;
  border-image: linear-gradient(to right, #ac7626, #d3a85a, #ac7626) 1;
}
.component__carousel--1 {
  *:focus {
    outline: 0 !important;
  }
  .carousel__bg {
    background: rgb(0, 157, 222);
    background: linear-gradient(
      180deg,
      rgba(0, 157, 222, 1) 0%,
      rgba(114, 202, 244, 1) 50%
    );
    height: 800px;
    position: relative;

    @media screen and (max-width: 600px) {
      background-size: 320%;
    }
    @media screen and (max-width: 321px) {
      background-size: 350%;
    }
  }
  .carousel__wrapper {
    height: 100%;
    margin: auto;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 100;
  }
  .carousel {
    width: 100%;
    margin: 0px auto;
  }
  .carousel__product {
    padding: 0px 20px;
    width: 100%;
  }
  .wrapper .slick-dots li button:before {
    font-size: 20px;
    color: #000000;
  }
  .slick-arrow:before {
    color: #ffffff;
  }

  .carousel__h1 {
    color: $color--smirnoff;
    font-size: 20px;
    font-style: italic !important;
    height: 80px;
    line-height: 23px;
    max-width: 700px;
    @media screen and (max-width: 920px) {
      font-size: 20px;
      line-height: 24px;
      height: 90px;
    }
    @media screen and (max-width: 725px) {
      height: auto;
    }
    @media screen and (max-width: 600px) {
      padding-bottom: 30px;
      font-size: 24px;
      line-height: 28px;
    }
  }

  .carousel__button {
    background: linear-gradient(
      to right,
      rgb(172, 118, 38),
      rgb(211, 168, 90),
      rgb(172, 118, 38)
    );
    color: #ffffff;
    padding: 10px 25px 10px 25px;
    font-size: 18px;
    &:hover {
      background: transparent;
      color: rgb(172, 118, 38);
      cursor: pointer;
    }
  }
  .carousel__img--product {
    margin: auto;
    max-width: 200px;
    width: 100%;
  }
  .carousel__surface {
    background: rgb(90, 182, 7);
    background: linear-gradient(
      180deg,
      rgba(90, 182, 7, 1) 0%,
      rgba(0, 136, 42, 1) 100%
    );
    background-size: cover;
    bottom: 0px;
    height: 350px;
    position: absolute;
    width: 100%;
  }

  .grad-border {
    width: 171px;
    margin: 0 auto;
    padding: 3px;
    border-width: 2px;
    border-style: solid;
    border-image: linear-gradient(to right, #ac7626, #d3a85a, #ac7626) 1;
  }
}
.component__carousel--2 {
  @media screen and (max-width: 600px) {
    padding-bottom: 100px !important;
  }
  *:focus {
    outline: 0 !important;
  }
  padding-bottom: 50px;
  .carousel__bg {
    background: rgb(0, 157, 222);
    background: linear-gradient(
      180deg,
      rgba(0, 157, 222, 1) 0%,
      rgba(114, 202, 244, 1) 50%
    );
    height: 800px;
    position: relative;

    @media screen and (max-width: 600px) {
      background-size: 320%;
    }
    @media screen and (max-width: 321px) {
      background-size: 350%;
    }
  }
  .carousel__wrapper {
    height: 100%;
    margin: auto;
    padding-top: 70px;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 100;
  }
  .carousel {
    width: 100%;
    margin: 0px auto;
  }
  .carousel__product {
    padding: 0px 20px;
    width: 100%;
  }
  .wrapper .slick-dots li button:before {
    font-size: 20px;
    color: #000000;
  }
  .slick-arrow:before {
    color: #ffffff;
  }

  .carousel__h1 {
    color: $color--smirnoff;
    font-size: 20px;
    font-style: italic !important;
    height: 105px;
    line-height: 23px;
    max-width: 700px;

    & > span {
      font-style: initial;
    }
    @media screen and (max-width: 920px) {
      font-size: 20px;
      line-height: 24px;
      height: 90px;
    }
    @media screen and (max-width: 807px) {
      height: 120px;
    }
    @media screen and (max-width: 753px) {
      height: auto;
      padding-bottom: 30px;
    }
    @media screen and (max-width: 600px) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .carousel__button {
    background: linear-gradient(
      to right,
      rgb(172, 118, 38),
      rgb(211, 168, 90),
      rgb(172, 118, 38)
    );
    color: #ffffff;
    padding: 10px 25px 10px 25px;
    font-size: 18px;
    &:hover {
      background: transparent;
      color: rgb(172, 118, 38);
      cursor: pointer;
    }
  }
  .carousel__img--product {
    margin: auto;
    max-width: 120px;
    width: 100%;
    @media screen and (max-width: 600px) {
      max-width: 90px;
    }
  }
  .carousel__surface {
    background: rgb(90, 182, 7);
    background: linear-gradient(
      180deg,
      rgba(90, 182, 7, 1) 0%,
      rgba(0, 136, 42, 1) 100%
    );
    background-size: cover;
    bottom: 0px;
    height: 350px;
    position: absolute;
    width: 100%;
  }

  .grad-border {
    width: 152px;
    margin: 0 auto;
    padding: 3px;
    border-width: 2px;
    border-style: solid;
    border-image: linear-gradient(to right, #ac7626, #d3a85a, #ac7626) 1;
  }
}
.product-title {
  font-size: 24px;
  line-height: 32px;
  color: $color--smirnoff;
  font-family: "Mark Pro";
  font-weight: bold;
  text-transform: uppercase;
}
.mw--1000 {
  max-width: 1000px;
}
.mp--m {
  font-family: "Mark Pro";
  font-weight: 500;
  text-transform: uppercase;
}
.cs-modal__copy-title {
  color: #bc0e2d;
  font-size: 22px;
  font-style: italic;
}
.cs-modal__copy-ingredients,
.cs-modal__copy-method {
  font-size: 13px;
  line-height: 17px;
}
.cs-modal {
  ::-webkit-scrollbar {
    display: none;
  }
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  background: rgba(0, 0, 0, 0.9);
  display: none;
  height: 100%;
  left: 0px;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1000;
}
.cs-modal__bg {
  ::-webkit-scrollbar {
    display: none;
  }
  background-color: #ffffff;
  background-image: url("marble-bg.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 500px;
  max-width: 668px;
  width: 100%;
  @media screen and (max-width: $width--xs) {
    height: 100%;
    max-height: none;
    border-radius: 0px;
  }
}
.cs-modal__padding {
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  @include flex-direction(column);
  height: 100%;
  width: 100%;
}
.cs-modal__row {
  ::-webkit-scrollbar {
    display: none;
  }
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(center);
  position: relative;
  height: 100%;
  width: 100%;
  @media screen and (max-width: $width--xs) {
    @include flex-direction(column-reverse);
  }
}
.cs-modal__col--6-6 {
  ::-webkit-scrollbar {
    display: none;
  }
  position: relative;
  width: 50%;
  @media screen and (max-width: $width--xs) {
    width: 100%;
  }
}
.cs-modal__row--1 {
  ::-webkit-scrollbar {
    display: none;
  }
  overflow: scroll;

  & .cs-modal__col--6-6 {
    height: 100%;
    @include flexbox();
    @include align-items(center);
    @include justify-content(center);
    @include flex-direction(column);
    @media screen and (max-width: $width--xs) {
      @include justify-content(center);
      height: auto;
    }
  }
}
.cs-modal__close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 50px;
  z-index: 10000;
}

.cs-modal__menu {
  ::-webkit-scrollbar {
    display: none;
  }
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  @include flex-direction(column);
  height: 50px;
  position: absolute;
  width: 100%;
  z-index: 100;
  & .cs-modal__img--chevron {
    position: absolute;
    right: 0px;
    max-width: 20px;
    width: 20px;
  }
}

.cs-modal__product-wrapper {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  font-size: 12px;
  height: 50px;
  min-height: 50px;
  padding-left: 15px;
  padding-right: 40px;
  text-align: left;
}
.cs-modal__product {
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;
  text-align: left;
  width: 100%;
}
.cs-modal__img--product {
  width: 80px;
  @media screen and (max-width: $width--xs) {
    width: 50px;
  }
}
.cs-modal__retailers {
  height: 100%;
  max-height: 100%;
  overflow: scroll;
}
.cs-modal__retailer {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  border-bottom: 1px solid #f0f0f0;
  height: 70px;
}
.cs-modal__retailer-logo {
  width: 70px;
}
.cs-modal__retailer-price {
  font-size: 13px;
  font-weight: 700;
  @include flex(1);
}
.cs-modal__retailer-cta {
  font-size: 10px;
  width: 80px;
}
.cs-modal__img--retailer-logo {
  display: block;
  width: 74px;
}
.cs-modal__a--retailer {
  color: #000000;
  text-decoration: none;
}
.cs-modal__copy {
  overflow: scroll;
  padding: 0px 20px;
}
.cs-modal__serve {
  width: 100%;
  @media screen and (max-width: $width--xs) {
    padding-bottom: 30px;
  }
}
.cs-modal__img--serve {
  ::-webkit-scrollbar {
    display: none;
  }
  max-width: 200px;
  width: 100%;
  @media screen and (max-width: 700px) {
    max-width: 80px;
  }
}

.cs-modal__copy-ingredients {
  ::-webkit-scrollbar {
    display: none;
  }
  color: #bc0e2d;
  font-family: "Mark Pro", sans-serif;
  font-size: 12px;
  padding: 30px 0px;
  text-transform: uppercase;
  & > div {
    margin-bottom: 5px;
  }
}
.cs-modal__copy-method {
  ::-webkit-scrollbar {
    display: none;
  }
  color: #bc0e2d;
  font-family: "Mark Pro", sans-serif;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  & > div {
    margin-bottom: 5px;
  }
}
</style>